import React from "react";

import { DataObject } from "mosaic-react-icons";
import { useGlobalValue } from "colbi_web_ui/lib/state/GlobalProvider";

import styles from "./RawData.module.sass";
import { SovosButton } from "mosaic-react";

const RawData = (props) => {
    const { label, data, entity } = props;
    const { pushModal, i18n } = useGlobalValue();

    if (!data) {
        return null;
    }

    return (
        <div className={`${styles["button"]} ${styles["raw-data"]}`}>
            <SovosButton
                startIcon={<DataObject />}
                variant={"text"}
                children={label}
                onClick={() => {
                    pushModal({
                        title: label,
                        data: { data, entity: `${i18n`${entity}`}` },
                        args: "",
                        view: "JsonViewer",
                    }).catch((err) => null);
                }}
            >
                {i18n`${label}`}
            </SovosButton>
        </div>
    );
};

export default RawData;
